export default __webpack_public_path__ + "static/media/henry-miller.b095e661.jpg";